import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getCurrentPaymentSchedule from './getCurrentPaymentSchedule'

const getPaymentScheduleDepositAmount = createSelector(
  getCurrentPaymentSchedule,
  (paymentSchedule): number => {
    if (!paymentSchedule?.eligible || !paymentSchedule?.charges) {
      return 0
    }
    const depositAmount = paymentSchedule.charges.find(schedule => schedule.paymentType === 'deposit')?.expectedAmount || 0
    return floatify(depositAmount)
  },
)

export default getPaymentScheduleDepositAmount
